import { ActionContext } from 'vuex';

import { MPK_BUSINESS_TIP_ACTIONS_NAME, MPK_BUSINESS_TIP_MUTATIONS_NAME } from './name';
import { TBusinessTipState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function fetchParticipantsList(
  context: ActionContext<TBusinessTipState, unknown>,
  params: TPaginationParams,
) {
  if (!context.state.participantsList.length) {
    return request(
      context,
      {
        url: links.businessTip.participants,
        name: MPK_BUSINESS_TIP_ACTIONS_NAME.fetchParticipantsList,
        mutate: MPK_BUSINESS_TIP_MUTATIONS_NAME.setParticipantsList,
      },
      params,
    );
  }
}

export async function fetchForeignParticipantsList(
  context: ActionContext<TBusinessTipState, unknown>,
  params: TPaginationParams,
) {
  if (!context.state.foreignParticipantsList.length) {
    return request(
      context,
      {
        url: links.businessTip.foreignParticipants,
        name: MPK_BUSINESS_TIP_ACTIONS_NAME.fetchForeignParticipantsList,
        mutate: MPK_BUSINESS_TIP_MUTATIONS_NAME.setForeignParticipantsList,
      },
      params,
    );
  }
}
